
// SVG Icon: data
export default { id: "terriajs-data" };
export const id = "terriajs-data";
export const name = "data";
